//Mainly needed for UT as this cannot be mocked otherwise. ctxsNative is defined in native bridge code.
//Disabling eslint with inline comment for below line as it is used for UT only.

declare let ctxsNative: any; // eslint-disable-line @typescript-eslint/no-explicit-any
export default ctxsNative;
